module.exports = __webpack_public_path__ + "static/img/logo114.3e37f2d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo114.png
// module id = 7zhF
// module chunks = 1